import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/buttons/Button';
import Card from '../components/Card/Card';
import SectionHeader from '../components/SectionHeader/SectionHeader';
import { isCapacitor } from '../utils/platform';
import { useAuth } from '../context/AuthContext';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import './Subscription.css';

function SubscriptionSuccess() {
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleContinue = async () => {
    setIsRefreshing(true);
    try {
      await refreshProfile();
      // Navigate to home after profile refresh
      navigate('/home');
    } catch (_) {
      // If refresh fails, force full reload to re-evaluate routing guards
      window.location.reload();
    }
  };

  return (
    <>
      {isCapacitor && (
        <div className="capacitor-topbar">
          <div className="topbar-content">
            <img src={`${process.env.PUBLIC_URL}/icon.png`} alt="Logo" className="topbar-logo" />
            <h2 className="topbar-title">voxia</h2>
          </div>
        </div>
      )}

      <div className="subscription-container" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px'
      }}>
        <Card className="card-large">
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 20px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, var(--color-success) 0%, #2e7d32 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 20px rgba(46, 125, 50, 0.3)'
            }}>
              <FaCheckCircle style={{ fontSize: '48px', color: 'white' }} />
            </div>

            <SectionHeader 
              icon={FaCheckCircle} 
              title="Paiement confirmé" 
              variant="success"
            />
            
            <p style={{ 
              fontSize: '16px', 
              color: '#666', 
              marginTop: '16px',
              marginBottom: '30px',
              lineHeight: '1.6'
            }}>
              Votre abonnement a été activé avec succès.<br />
              Merci pour votre confiance !
            </p>

            <Button 
              variant="primary" 
              onClick={handleContinue}
              disabled={isRefreshing}
              icon={FaArrowRight}
              style={{ minWidth: '200px' }}
            >
              {isRefreshing ? 'Chargement...' : 'C’est parti !'}
            </Button>
          </div>
        </Card>
      </div>
    </>
  );
}

export default SubscriptionSuccess;